import EditInstutionForm from "../components/admin/institution/EditInstutionForm";
import Admin from "./Admin";

const EditInstution = () => {
    return (<Admin>
        <EditInstutionForm/>
    </Admin>);
}
 
export default EditInstution;